var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33333H14V1C14 0.448667 13.5513 0 13 0H3C2.44867 0 2 0.448667 2 1V3.33333H1C0.448667 3.33333 0 3.782 0 4.33333V11.6667C0 12.218 0.448667 12.6667 1 12.6667H3.33333V15C3.33333 15.5513 3.782 16 4.33333 16H11.6667C12.218 16 12.6667 15.5513 12.6667 15V12.6667H15C15.5513 12.6667 16 12.218 16 11.6667V4.33333C16 3.782 15.5513 3.33333 15 3.33333ZM2.66667 1C2.66667 0.816333 2.81633 0.666667 3 0.666667H13C13.1837 0.666667 13.3333 0.816333 13.3333 1V3.33333H2.66667V1ZM11.6667 15.3333H4.33333C4.14967 15.3333 4 15.1837 4 15V9.66667H12V15C12 15.1837 11.8503 15.3333 11.6667 15.3333ZM15.3333 11.6667C15.3333 11.8503 15.1837 12 15 12H12.6667V9.66667H14V9H2V9.66667H3.33333V12H1C0.816333 12 0.666667 11.8503 0.666667 11.6667V4.33333C0.666667 4.14967 0.816333 4 1 4H15C15.1837 4 15.3333 4.14967 15.3333 4.33333V11.6667Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 6H12V6.66667H13.6667V6Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13H5.33333V13.6667H10.6667V13Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H5.33333V11.6667H8V11Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.eb0af159a2a2320dee4543922d04da8b.svg";
export { ForwardRef as ReactComponent };